import React from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons'
import './LoadingScreen.css';

/**
 * Font Awesome Install Instructions
 * https://fontawesome.com/how-to-use/on-the-web/setup/using-package-managers
 * 
 * npm i --save @fortawesome/fontawesome-svg-core  @fortawesome/free-solid-svg-icons @fortawesome/react-fontawesome
 * npm install --save @fortawesome/fontawesome-pro
 * npm i --save @fortawesome/pro-regular-svg-icons
 * 
 * Note: The above was all installed but maybe only the following needs to be installed
 * 
 * npm i --save @fortawesome/fontawesome-svg-core  @fortawesome/fontawesome-pro @fortawesome/pro-regular-svg-icons @fortawesome/react-fontawesome
 */
function LoadingScreen(){
  return (
    <div className="loading">
      {/* <FontAwesomeIcon icon={faSpinnerThird} className="icon" pulse /> */}
      <p>
      loading...
      </p>
    </div>
  );
}
          
export default LoadingScreen;
